import { AuthService } from './../../../../core/services/auth.service';
import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RequestSentComponent } from '../../../../components/settings/request-sent/request-sent.component';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { ProfileService } from 'src/app/core/services/profile.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorMessageComponent } from 'src/app/components/all-modals/error-message/error-message.component';
import { PublicationPreviewWrapperComponent } from 'src/app/components/material-detail/publication-preview-wrapper/publication-preview-wrapper.component';

@Component({
  selector: 'app-request-varification',
  templateUrl: './request-varification.component.html',
  styleUrls: ['./request-varification.component.scss']
})
export class RequestVarificationComponent implements OnInit {

  @ViewChild('photo_id_proof', { static: true }) verificationPhoto: ElementRef;
  @Input() public currentUser: any;

  imagePath: any;
  message: string;
  showPreview: boolean;
  isImageError: boolean = false;
  fileRequestVerification: File;
  imgURLRequestVerification: any = '';
  verification_proof_type: any = '';
  requestVerificationForm: FormGroup;
  showPreviewRequestVerification: boolean;
  isImagePreviewRequestVerification = false;
  submittedRequestVerification: boolean = false;
  publicationUploadType = [
    'docx',
    'pdf',
    'png',
    'jpg',
    'jpeg',
  ];
  currentToken: any;
  fileSizeError: boolean = false;
  verificationTypes: any;
  selectedType: any;

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private _profileService: ProfileService,
    private _authService: AuthService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit() {
    this.getVerificationTypes();

    this.requestVerificationForm = this.formBuilder.group({
      name: ["", Validators.compose([Validators.required, this.noWhitespaceValidator])],
      known_as: ["", Validators.compose([Validators.required, this.noWhitespaceValidator])],
      verification_proof_type_id: ['', Validators.required],
      // verification_proof_no: ["", Validators.required]
    });
    this.currentToken = this.currentUser.token;
    if(this.currentUser.user.user_type === 'individual'){
      this.requestVerificationForm.controls['name'].setValidators(Validators.pattern(REGEX_PATTERNS.NAME_PATTERN));
      this.requestVerificationForm.controls['known_as'].setValidators(Validators.pattern(REGEX_PATTERNS.NAME_PATTERN));
    } else {
      this.requestVerificationForm.controls['name'].setValidators(Validators.pattern(REGEX_PATTERNS.BUISNESS_NAME_PATTERN));
      this.requestVerificationForm.controls['known_as'].setValidators(Validators.pattern(REGEX_PATTERNS.BUISNESS_NAME_PATTERN));
    }
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  getVerificationTypes() {

    this._profileService.fetchVerificationTypes(this.currentUser.user.user_type).subscribe(
      (response: any) => {
        if (response.success) {
          this.verificationTypes = response.data.verification_proofs
        }
      });
  }

  onChangeType(typeID) {
    this.verificationTypes.forEach(element => {
      if (element.id == typeID)
        this.selectedType = element;
    });
  }

  closeDialog(status?) {
    this.activeModal.close(status);
  }

  filesDropped(files) {
    const FileObj = files[0].file;
    this.preview({ 0: FileObj });
  }

  preview(files) {
    if (files.length === 0)
      return;

    this.isImagePreviewRequestVerification = false;
    let mineType = files[0].type;

    var reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);

    this.isImageError = false;
    this.fileSizeError = false;

    var fileName = files[0].name.split('.');
    const extension = fileName[fileName.length - 1];

    if ((!mineType.match(/image\/*/)) && (!mineType.match(/pdf\/*/)) && (!mineType.match(/document\/*/)) || (mineType.match(/svg\/*/))) {
      this.isImageError = true;
      return;
    }
    if (files[0].size / 1048576 > 4.999) {
      this.fileSizeError = true;
      return;
    }

    reader.onload = (_event) => {
      if (mineType.match(/image\/*/)) {
        this.isImagePreviewRequestVerification = true;
      }
      this.showPreviewRequestVerification = true;
      this.imgURLRequestVerification = reader.result;
      this.fileRequestVerification = files[0];
    }

    this.isImageError = false;
    this.fileSizeError = false;
  }

  removeFile() {
    this.imgURLRequestVerification = '';
    this.showPreviewRequestVerification = false;
  }

  openConfirmModal() {
    this.closeDialog(true);
    this.modalService.open(RequestSentComponent, { centered: true, backdrop: 'static', keyboard: false });
  }

  onSubmit() {
    this.submittedRequestVerification = true;
    if (this.requestVerificationForm.invalid || this.imgURLRequestVerification == '' || (this.selectedType.name == 'Other' && this.verification_proof_type == '') || this.fileSizeError || this.isImageError) {
      return;
    }

    this.spinner.show();
    let params;
    params = {
      ...this.requestVerificationForm.value,
    }
    params.photo_id_proof = this.fileRequestVerification;

    if (this.selectedType.name == 'Other') {
      params.other_proof_type = this.verification_proof_type;
    }

    this._profileService.requestVerification(params).subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.success) {
          this.getUserData();
        }
        else {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = response.message;
        }
      })

  }

  getUserData() {
    this._authService.getCurrentUserData(this.currentUser.user.id).subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.success) {
          this.redirectUser(response.data.user);
          this.openConfirmModal();
        }
      });
  }

  redirectUser(userObj) {
    const currentUser = {
      token: this.currentToken,
      user: userObj
    }

    this.currentUser = currentUser;
    let rememberMe = localStorage.getItem('rememberMe');

    if (rememberMe == 'true')
      localStorage.setItem('currentUser', JSON.stringify(currentUser));
    else
      sessionStorage.setItem('currentUser', JSON.stringify(currentUser));
  }

  filePreview(){
    const modelRef = this.modalService.open(PublicationPreviewWrapperComponent, { centered: true, size: "lg", windowClass: 'pdf-modal' });
    modelRef.componentInstance.url = this.imgURLRequestVerification;
  }
}
